


































































import {Emit} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';
import {Tache} from '@/models';

import storeTache from '@/stores/modules/tache';

import InputPhone from '@/components/Input/Phone.vue';
import InputCountry from "@/components/Input/Country.vue";
import InputZipCode from "@/components/Input/ZipCode.vue";
import storeProjet from "@/stores/modules/projet";

@Component({
	components: {
		InputPhone,
		InputCountry,
		InputZipCode,
	}
})
export default class CrudTacheEdit extends AbstractEditVue<Tache> {

	// DF: utiliser pour la création d'un tache uniquement
	// en modification on passe par la light
	private step: number = 1;
	private storeProjet = storeProjet;

	public constructor() {
		super(
			storeTache,
			'Tache modifié',
			'Tache créé',
		);
	}

	protected async onSubmit(): Promise<void> {
		super.onSubmit();
		this.step = 1;
	}

	public async mounted(): Promise<void> {
		await storeProjet.dispatch('getAll');
		await super.mounted();
	}

	public async refresh(): Promise<void> {
		await super.refresh();
		//console.log('route tache edit = ' + this.$route.name);
		if (this.$route.name === 'tache-edit') {
			this.$route.meta.title = 'Modification  d\'un tache';
		}
	}

}
